import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { useEffect } from 'react';
import useUtil from './useUtil';
import { sectionFragmentER } from '../../components/pge-plus-common/queries/fragments';

export const getApplicationSectionQuery = gql`
  query($input: GetApplicationSectionInput!) {
    getApplicationSection(input: $input) {
      ...sectionFragment
    }
  }
  ${sectionFragmentER}
`;
export const useGetApplicationSectionERQuery = (
  applicationId: String,
  sectionId: String,
) => {
  const { setErrorNotification } = useUtil();

  const [
    getApplicationSection,
    { loading, error, data: sectionData },
  ] = useLazyQuery(getApplicationSectionQuery, {
    context: {
      pgePlus: true,
    },
    fetchPolicy: 'no-cache',
    onError: () => setErrorNotification(true),
  });

  useEffect(() => {
    if (true) {
      getApplicationSection({
        variables: {
          input: {
            applicationId: applicationId,
            sectionId: sectionId,
          },
        },
      });
    }
  }, []);

  return {
    sectionData,
    loading,
    error,
  };
};
